import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { EnvelopeSimple, Check } from "@phosphor-icons/react";

export default function NewsletterSignup({ tenant = null, compact = false }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email, ...(tenant ? { tenant_slug: tenant } : {}) });
      setDone(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Could not subscribe");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-[#39FF14] text-sm font-bold" data-testid="newsletter-success">
        <Check size={18} weight="bold" /> You're on the list! Watch your inbox for weekly deals.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? "" : "max-w-md"} data-testid="newsletter-form">
      {!compact && (
        <div className="flex items-center gap-2 mb-2">
          <EnvelopeSimple size={18} weight="fill" color="#00FFFF" />
          <p className="font-display font-bold uppercase text-sm">Get the hottest deals weekly</p>
        </div>
      )}
      <div className="flex">
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com" data-testid="newsletter-email-input"
          className="flex-1 bg-zinc-900 border border-zinc-700 focus:border-[#00FFFF] outline-none px-3 py-2.5 text-sm text-white"
        />
        <button type="submit" disabled={busy} data-testid="newsletter-subscribe-button"
          className="px-4 bg-[#00FFFF] text-black text-xs font-black uppercase tracking-widest hover:bg-[#FF007F] hover:text-white transition-colors disabled:opacity-50">
          {busy ? "…" : "Join"}
        </button>
      </div>
      {err && <p className="text-[#FF007F] text-xs mt-1">{err}</p>}
    </form>
  );
}
